export default __webpack_public_path__ + "static/media/show-placeholder.698b13fd.jpg";